import request from './request.js'

const $api = {
    region: {
        /**
         * @function 获取地区集合
         * @return {Object} [{_id,name,group}]
         */
        list () {
            return request('region/list', {}, {
                success: function (res) {
                    const groupData = {
                        TOP: [{
                            _id: 0,
                            name: '全国'
                        }]
                    };
                    res.result.forEach(data => {
                        if (!groupData[data.group]) groupData[data.group] = [];
                        const { _id, name } = data;
                        groupData[data.group].push({ _id, name })
                    })
                    console.log(groupData)
                    res.result = groupData;
                    return res
                }
            })
        }
    },
    hotspot: {
        /**
         * @function 获取热点关注列表
         * @parmas {number} ?position 位置(home 首页，information 资讯侧边栏)
         * @parmas {number} ?size  查询条数
         * @return {Array} [{coverUrl,name,intro,jumpUrl}]
         */
        list (params) {
            return request('hotspot/list', params);
        }
    },
    college: {
        /**
         * @function 获取合作院校指定条件集合
         * @parmas {number} ?index 开始索引
         * @parmas {number} ?size  查询条数
         * @parmas {string} ?regionId  地区标识
         * @return {object} {index,more,list:[{_id,coverUrl,name,address}]}
         */
        page (params) {
            return request('college/page', params);
        },
        /**
         * @function 获取合作院校详情
         * @parmas {number} _id    院校标识
         * @return {object} {_id,coverUrl,name,intro,applyCondition,code,address,mapPoint,phont,url,?photos}
         */
        info (_id) {
            return request('college/info', {
                _id
            });
        },
        /**
         * @function 获取合作院校关联的班型专业集合
         * @parmas {number} _id    院校标识
         * @return {Array} [{_id,name,intro,professions:[{_id,iconUrl,name,plan,relationId}]}]
         */
        relation (_id) {
            return request('college/relation', {
                _id
            });
        },
    },
    class: {
        /**
         * @function 获取班型集合
         * @return {Array} [{_id,name,intro}]
         */
        list () {
            return request('class/list');
        },
        /**
         * @function 获取班型集合(含专业)
         * @return {Array} [{_id,name,intro,professions:[{_id,iconUrl,name,plan,relationId,college:{_id,name}}]}]
         */
        relation () {
            return request('class/relation');
        }
    },
    form: {
        /**
         * @function C端表单
         * @parmas {objct}  {name,phone,district}
         * @return {objct}  {success:_id / error: code,message}
         */
        customer (params) {
            return request('customer/submit', params, {
                loading: true,
                loadingText: '提交中...'
            });
        },
        /**
         * @function B端表单
         * @parmas {objct}  {name,linkman,phone}
         * @return {objct}  {success:_id / error: code,message}
         */
        business (params) {
            return request('organization/submit', params, {
                loading: true,
                loadingText: '提交中...'
            });
        }
    }
}

export default $api